import Image from "next/image";
import aiAgentIcon from "@/assets/images/AI-Agent.png";
import SparkleIcon from "@/assets/images/cashless-ai-v2.svg";
import { cn } from "@/lib/utils";

export interface AiAgentHeroProps {
  /** The signed-in user's first name (Figma: "Hey Ahmad"). */
  name: string;
  /** `lg` — the full page (213:201709); `sm` — the compact Ask-AI popover (213:202971). */
  size?: "lg" | "sm";
}

/**
 * Greeting hero for the AI agent's empty state — the brand sparkle + "Hey {name}"
 * headline and the "grow your Business" subline. `lg` is the full page (46px
 * headline); `sm` is the compact top-nav popover (20px headline).
 */
export function AiAgentHero({ name, size = "lg" }: AiAgentHeroProps) {
  const lg = size === "lg";
  return (
    <div className="flex flex-col items-center gap-2 text-center">
      <div className={cn("flex items-center", lg ? "gap-3" : "gap-2")}>
        {lg ? (
          <SparkleIcon className="size-9 shrink-0 text-primary-500" />
        ) : (
          // Compact popover — the new gradient brand icon (matches the header).
          <Image
            src={aiAgentIcon}
            alt=""
            width={24}
            height={24}
            className="size-6 shrink-0"
          />
        )}
        <h1
          className={cn(
            "font-semibold text-text-primary tracking-tight",
            lg ? "text-[46px] leading-[56px]" : "text-xl leading-7",
          )}
        >
          Hey {name}
        </h1>
      </div>
      <p
        className={cn(
          lg
            ? "text-text-secondary text-[24px] leading-[32px]"
            : "text-base text-text-tertiary leading-6",
        )}
      >
        Get ready to grow your Business
      </p>
    </div>
  );
}
